import { getFilteredTruthyFieldsObj } from '../../../../shared/utils/sortingAndGroupingUtil';
import { CreateEntitySubscriptionInfo } from '../../../interfaces/entitySubscription';
import { CreateSubscriptionFormValues } from '../../../interfaces/createSubscription';

export const getSubscriptionInfoFromFormValue = ({
  subscriptionPrice,
  ...data
}: CreateSubscriptionFormValues): CreateEntitySubscriptionInfo => {
  const paymentInfo = {
    ...subscriptionPrice,
    ...data,
  };

  const filteredPaymentInfo = getFilteredTruthyFieldsObj(paymentInfo);

  return filteredPaymentInfo as CreateEntitySubscriptionInfo;
};
